<template>
  <view-container
    class="view-product-register-submodule"
    :title="subModuleTitle"
    :breadcrumbs="breadcrumbs"
    :loading="loading"
    header
    contentHeader
  >
    <template #header>
      <div class="d-flex flex-row align-items-center justify-content-between">
        <product-dropdown v-if="product" :product="product" />
        <button
          v-if="product && product.is_blitz_members"
          class="btn btn-40 btn-link btn-new-link"
          @click="openClubLogged"
        >
          Acessar área de membros
          <i
            class="ml-5 fa-solid fa-arrow-up-right-from-square font-weight-bold"
          ></i>
        </button>
      </div>
    </template>
    <div class="row">
      <div class="view-content-aside col-lg-3 pr-0 d-none d-lg-block">
        <steps
          class="pt-6 mt-3"
          :step="currentStep"
          :names="steps"
          @change-step="v => (currentStep = v)"
        />
      </div>

      <div class="col-lg-9 pl-6">
        <div v-if="currentStep === 1">
          <register-sub-module-basic
            :product-id="$route.params.id"
            :form="form"
          />
        </div>
        <div v-if="currentStep === 2">
          <register-sub-module-customization
            :product-id="$route.params.id"
            :form="form"
          />
        </div>

        <div
          class="d-flex flex-column flex-md-row d-block justify-content-between mt-9 pb-5"
        >
          <button
            class="btn mb-5 btn-outline-secondary px-5 order-3 order-md-0"
            @click="back"
          >
            <span v-if="currentStep === 1">Cancelar</span>
            <span v-else class="d-flex align-items-center">
              <i class="icon-angle-left mr-6" />
              Voltar
            </span>
          </button>
          <div class="flex-fill"></div>
          <button
            class="btn btn-outline-secondary px-5 mb-5 mr-md-3 order-2 order-md-1"
            :disabled="!isValid"
            @click="saveAsDraft"
          >
            Salvar Rascunho
          </button>
          <button
            v-if="currentStep === 2"
            class="btn mb-5 mr-md-3 px-5 order-1 order-md-2"
            :class="
              isValid ? 'btn-new-outline-primary ' : 'btn-outline-secondary'
            "
            :disabled="!isValid"
            @click="next((createNew = true))"
          >
            <loading :show="loading && createNew">
              Salvar e criar novo
            </loading>
          </button>
          <button
            class="btn d-flex mb-5 align-items-center px-5 order-0 order-md-3"
            :class="isValid ? 'btn-new-primary ' : 'btn-secondary'"
            :disabled="!isValid"
            @click="next((createNew = false))"
          >
            <loading
              v-if="currentStep === steps.length"
              :show="loading && !createNew"
            >
              Salvar
            </loading>
            <span v-else class="d-flex align-items-center">
              Próximo
              <i class="icon-angle-right ml-6" />
            </span>
          </button>
        </div>
      </div>
    </div>
  </view-container>
</template>

<script>
import RegisterSubModuleBasic from "@/components/product/details/content/RegisterSubModuleBasic";
import RegisterSubModuleCustomization from "@/components/product/details/content/RegisterSubModuleCustomization";
import ProductDropdown from "@/components/product/ProductDropdown.vue";
import ViewContainer from "@/components/ViewContainer.vue";
import { formFields, toHumanDate } from "@/functions/helpers";
import MemberAreaMixin from "@/mixins/memberArea.js";
import get from "lodash/get";
import { mapState } from "vuex";

export default {
  mixins: [MemberAreaMixin],
  components: {
    RegisterSubModuleCustomization,
    RegisterSubModuleBasic,
    ViewContainer,
    ProductDropdown
  },
  computed: {
    ...mapState("membersModules", ["module"]),
    ...mapState("product", ["product"]),
    subModuleTitle() {
      return this.$route.params?.submodule_id
        ? "Editando Submódulo"
        : "Novo Submódulo";
    },
    breadcrumbs() {
      return [
        { link: "product", title: "Meus produtos" },
        {
          link: "product-details",
          title: this.product ? this.product["name"] : "...",
          params: { id: this.$route.params.id }
        },
        {
          link: "product-member-area-modules",
          title: "Conteúdo"
        },
        {
          link: "product-member-area-modules-detail",
          params: {
            id: this.$route.params.id,
            module_id: this.$route.params.module_id
          },
          title: "Módulo"
        },
        {
          title: this.$route.params?.submodule_id
            ? get(this.module, "name", "Editar Submódulo")
            : "Novo Submódulo"
        }
      ];
    },
    isValid() {
      return this.form.name;
    }
  },
  data() {
    return {
      currentStep: 1,
      steps: ["Informações básicas", "Personalização"],
      createNew: false,
      ...formFields(
        [
          "name",
          "picture",
          "cover_mobile",
          "header",
          "product_id",
          "parent",
          "days_to_release",
          "release_at"
        ],
        {
          parent: this.$route.params.module_id,
          product_id: this.$route.params.id
        }
      ),
      nav: "info",
      params: {
        product_id: this.$route.params.id,
        module_id: this.$route.params.module_id,
        limit: 1000,
        offset: 0
      },
      loading: false,
      search: "",
      editedIndex: null,
      actions: [
        {
          text: "Editar módulo",
          class: "",
          icon: "fa-solid fa-pen",
          confirmation: {
            enable: false
          },
          event: "edit"
        },
        {
          text: "Remover",
          class: "text-danger",
          icon: "icon-trash",
          confirmation: {
            enable: true,
            text: "Deseja mesmo excluir este módulo?"
          },
          event: "remove"
        }
      ]
    };
  },
  mounted() {
    this.dispatch();
  },
  methods: {
    saveOrder() {
      this.$store.dispatch("membersModules/reorder", this.module.sub_modules);
    },
    editmodule(module) {
      this.$router.push({
        name: "product-members-module-edit",
        params: { module_id: module.id }
      });
    },
    removemodule(module) {
      this.$store.dispatch("membersModules/deleteSub", module.id).then(() => {
        this.$store.dispatch("membersModules/getDetails", this.module.id);
        this.$message.success("Submódulo apagado.");
      });
    },
    searching(v) {
      this.search = v;
    },
    refresh() {
      this.dispatch();
    },
    dispatch() {
      this.loading = true;
      this.$store
        .dispatch("membersModules/getDetails", this.$route.params.submodule_id)
        .then(data => {
          this.form = {
            ...data,
            release_at: toHumanDate(data.release_at)
          };
        })
        .finally(() => {
          this.loading = false;
        });
    },
    submit() {
      this.loading = true;

      const data = {
        ...this.form,
        product_id: this.params.product_id,
        picture_mobile: this.form.cover_mobile
      };
      let action = "membersModules/post";

      if (this.$route.params.submodule_id) {
        data.id = this.$route.params.submodule_id;
        action = "membersModules/putSub";
      }

      if (!this.days_to_release) {
        data.days_to_release = 0;
      }

      if (this.release_at) {
        data.release_at = toComputerDate(data.release_at);
      } else {
        data.release_at = null;
      }

      this.$store
        .dispatch(action, data)
        .then(() => {
          this.$message.success("Salvo com sucesso");
          if (this.createNew) {
            this.$router.go(0);
          } else {
            this.$router.go(-1);
          }
        })
        .catch(error => {
          this.errors = error.response.data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    back() {
      if (this.currentStep === 1) {
        this.$router.go(-1);
      } else {
        this.currentStep--;
      }
    },
    saveAsDraft() {
      this.form.status = "draft";
      this.submit();
    },
    next() {
      if (this.currentStep === this.steps.length) {
        this.form.status = "published";
        this.submit();
      } else {
        this.currentStep++;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.view-product-register-submodule {
  .card {
    border-radius: 8px;
    background: rgba(255, 255, 255, 0.16);
    box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.08);
    border: 1px solid rgba(255, 255, 255, 0.32);

    &:hover {
      border: 1px solid rgba(207, 174, 255, 0.86);
    }
  }

  .name {
    color: rgba(59, 59, 74, 0.9);
    font-size: 14px;
    font-weight: 400;
  }
  .handle {
    cursor: grab;
  }
  .view-content-aside {
    border-right: 1px solid #e1dfe6;
  }
  .icon-angle-right,
  .icon-angle-left {
    font-size: 18px;
    margin-bottom: 1px;
    font-weight: 900;
  }
  .title {
    font-size: 18px !important;
    font-weight: 400;
  }
}
</style>
